var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnion13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.59788 2.87366L16.9323 0.0645018C17.4821 -0.0644437 18.0595 0.0011807 18.5663 0.250249L3.14402 15.6751C2.9815 15.3416 2.89608 14.9758 2.89417 14.6049V11.9632C2.89432 11.742 2.80653 11.5299 2.65014 11.3735L1.21932 9.94272C0.577286 9.30033 0.162888 8.4656 0.0392522 7.56583C-0.273762 5.28744 1.31949 3.18668 3.59788 2.87366ZM4.32244 16.8527L19.7473 1.43203C19.9984 1.94692 20.0624 2.53324 19.928 3.09021L17.1139 16.4571C16.8922 18.0046 15.8118 19.2923 14.3264 19.7793C13.8955 19.925 13.4437 19.9996 12.9888 20C11.8871 19.9991 10.8312 19.5591 10.0548 18.7774L8.62317 17.3466C8.46736 17.1899 8.25534 17.102 8.03434 17.1026H5.39262C5.02167 17.1007 4.65592 17.0152 4.32244 16.8527Z",
    fill: "#F26639"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion13);
export default __webpack_public_path__ + "static/media/Union (13).c0fd4aad21b40eebcd5e657172a613e4.svg";
export { ForwardRef as ReactComponent };